import Reel from "./Reel";
import ReelSpinner from "./ReelSpinner";
import ReelsConfig from "./ReelsConfig";
import ReelPrinter from "./ReelPrinter";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import { getRandomInt } from "../../helpers";

class Reels {

    protected _gameset: any;
    protected _columns: number;
    protected _config: SystemConfig;
    protected _reels: Reel[];
    protected _spinners: ReelSpinner[];
    protected _printer: ReelPrinter;
    protected _reelsConfig: ReelsConfig;

    protected _shift: number;
    protected _symbolsHeight: number;
    protected data: any;

    constructor(gameset: any, columns: number, config: SystemConfig) {

        this._gameset = gameset;
        this._columns = columns;

        /**
         * @type {Array<Reel>}
         * @private
         */
        this._reels = [];

        /**
         * @type {Array<ReelSpinner>}
         * @private
         */
        this._spinners = [];

        this._config = config;
        this._reelsConfig = new ReelsConfig();

        this._shift = this._gameset['game']['symbolModel']['shift'] ? this._gameset['game']['symbolModel']['shift'] : 0;
        this._symbolsHeight = this._gameset['game']['symbolModel']['symbolSize']['height'];
        let x = this._gameset['game']['symbolModel']['baseMatrix']['x'];
        let y = this._gameset['game']['symbolModel']['baseMatrix']['y'];

        this._printer = new ReelPrinter(x, y, this._symbolsHeight, this._shift);

        this.data = {};
    }

    create() {

        this._reelsConfig.init(this._config.get(CONFIG_PARAMS.BEHAVIOR));
        this._reelsConfig.setSymbolHeight(this._symbolsHeight);
        this._reelsConfig.setSymbolOffsetY(this._shift);

        for(let i = 0; i < this._columns; i++) {
            let reel = new Reel(i);
            this._reels[i] = reel;

            let spinner = new ReelSpinner(reel, this._printer, this._reelsConfig);
            this._spinners[i] = spinner;
            // reel.register(spinner);
        }
    }

    print(id: number = null) {

        if(id != null) {
            this._printer.print(this.getReel(id));
            return;
        }

        for(let i = 0; i < this._reels.length; i++) {
            this._printer.print(this.getReel(i));
        }
        //this._printer.print(this.getReel(0));
    }

    /**
     * @return {Array<Reel>}
     */
    getReels() {
        return this._reels;
    }

    /**
     * @param {number} id
     * @return {Reel}
     */
    getReel(id) {
        return this._reels[id];
    }

    /**
     * @return {Array<ReelSpinner>}
     */
    getSpinners() {
        return this._spinners;
    }

    /**
     * @param id
     * @return {ReelSpinner}
     */
    getSpinner(id) {
        return this._spinners[id];
    }

    setSpinSymbols(symbols) {
        for(let i = 0; i < this._reels.length; i++) {
            this.getReel(i).setSpinSymbols(symbols[i]);
        }
    }

    setStartPositions() {
        let positions = this._config.get(CONFIG_PARAMS.START_SYMBOLS_POSITION)
        for(let i = 0; i < this._columns; i++) {
            let pos = positions ? positions[i] : getRandomInt(0, this._reels[i].getSpinSymbols().length);
            this._reels[i].setSymbolsPosition(pos);
        }
    }

    setResultSymbols(symbols) {
        for(let i = 0; i < this._reels.length; i++) {
            this.getReel(i).setResSymbols(symbols[i]);
        }
    }

    initSymbols() {
        for(let i = 0; i < this._reels.length; i++) {
            this.getReel(i).initSymbols();
        }
    }

    getSymbols() {
        let symbols = [];
        this.getReels().forEach((reel) => {
            symbols.push(...reel.getSymbols());
        });
        return symbols;
    }

    getSymbolsMatrix() {
        let symbols = [];
        for(let i = 0; i < this._reels.length; i++) {
            symbols[i] = [];
            this.getReel(i).getSymbols().forEach(symbol => {
                symbols[i].push(symbol);
            });
        }
        return symbols;
    }

    getSpinSymbols() {
        let symbols = [];
        this.getReels().forEach((reel) => {
            symbols.push(...reel.getSpinSymbols());
        });
        return symbols;
    }

    getResultSymbols() {
        let symbols = [];
        this.getReels().forEach((reel) => {
            symbols.push(...reel.getResSymbols());
        });
        return symbols;
    }

    getResultSymbolsMatrix() {
        let symbols = [];
        for(let i = 0; i < this._reels.length; i++) {
            symbols[i] = [];
            this.getReel(i).getResSymbols().forEach(symbol => {
                symbols[i].push(symbol);
            });
        }
        return symbols;
    }

    startReel(id) {
        return this._spinners[id].start();
    }

    stopReel (id) {
        this._spinners[id].stop();
    }

    stop() {
        for(let reel of this._reels) {
            this.stopReel(reel.id);
        }
    }

    forceStop () {
        for(let reel of this._reels) {
            this._spinners[reel.id].forcestop();
        }
    }

    isForceStop() {
        for(let reel of this._reels) {
            if(this._spinners[reel.id].getForceStop()) {
                return true;
            }
        }

        return false;
    }

    getReelsConfig() {
        return this._reelsConfig;
    }

    /**
     * @param {number} reelId
     * @param {number} count
     */
    setSymbolsToStoppingDelay(reelId, count) {
        this.getSpinner(reelId).setSymbolsToStoppingDelay(count);
    }
}

export default Reels;
